import { useState } from "react";

const useAddProductForm = (callback) => {
  const [inputsForProducts, setInputsForProducts] = useState({});

  const handleSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }
    callback();
  };

  const handleInputChange = (event) => {
    event.persist();
    setInputsForProducts((inputsForProduct) => ({
      ...inputsForProduct,
      [event.target.name]: event.target.value,
    }));
  };

  return {
    handleSubmit,
    handleInputChange,
    inputsForProducts,
  };
};

export default useAddProductForm;
